export class RewardTypes {
  public static item = 'rewardItem';
  public static monster = 'rewardMonster';
  public static egg = 'rewardEgg';

  public static list(): string[] {
    return [
      this.item,
      this.monster,
      this.egg
    ];
  }
}

export class RewardModel {
  public name: string;
  public rewardType: string;

  static generateModel(json: any): RewardModel {
    const reward = new RewardModel();
    reward.name = json.name;
    reward.rewardType = json.rewardType;
    return reward;
  }

  static generateModels(jsonList: any[]): RewardModel[] {
    const list = [];
    for (const json of jsonList) {
      if (json.rewardType === RewardTypes.item) {
        list.push(ItemRewardModel.generateModel(json));
      } else if (json.rewardType === RewardTypes.monster) {
        list.push(MonsterRewardModel.generateModel(json));
      } else if (json.rewardType === RewardTypes.egg) {
        list.push(EggRewardModel.generateModel(json));
      } else {
        list.push(this.generateModel(json));
      }
    }
    return list;
  }
}

export class ItemRewardModel extends RewardModel {
  public itemId: string;
  public numItems: number;

  constructor() {
    super();
    this.rewardType = RewardTypes.item;
  }

  static generateModel(json: any): ItemRewardModel {
    const reward = new ItemRewardModel();
    reward.name = json.name;
    reward.rewardType = json.rewardType;
    reward.itemId = json.itemId;
    reward.numItems = json.numItems;
    return reward;
  }
}

export class MonsterRewardModel extends RewardModel {

  public monsterId: string;
  public familyId: string;
  // Unique id of the skin, null or empty means the default skin.
  public skinId: string;
  public xp: number;
  public abilityOneLevel: number;
  public abilityTwoLevel: number;
  public abilityThreeLevel: number;
  public abilityFourLevel: number;

  constructor() {
    super();
    this.rewardType = RewardTypes.monster;
  }

  static generateModel(json: any): MonsterRewardModel {
    const reward = new MonsterRewardModel();
    reward.name = json.name;
    reward.rewardType = json.rewardType;
    reward.monsterId = json.monsterId;
    reward.familyId = json.familyId;
    reward.skinId = json.skinId || null;
    reward.xp = json.xp;
    reward.abilityOneLevel = json.abilityOneLevel || 1;
    reward.abilityTwoLevel = json.abilityTwoLevel || 0;
    reward.abilityThreeLevel = json.abilityThreeLevel || 0;
    reward.abilityFourLevel = json.abilityFourLevel || 0;
    return reward;
  }
}

/**
 * An egg that hatches once the student has answered numRequired questions correctly.
 * itemId is the kind of egg, numRequired the correct answers needed.
 */
export class EggRewardModel extends RewardModel {
  public itemId: string;
  public numRequired: number;

  constructor() {
    super();
    this.rewardType = RewardTypes.egg;
  }

  static generateModel(json: any): EggRewardModel {
    const reward = new EggRewardModel();
    reward.name = json.name;
    reward.rewardType = json.rewardType;
    reward.itemId = json.itemId;
    reward.numRequired = json.numRequired;
    return reward;
  }
}
